/* Heading icons (snippets/rv-heading-icon.liquid, assets/rv-base.css "Heading icon"; Cris, 2026-10-04).
   The heading is a flex row: the title text and the circle. A wrapped title's box fills the row, which would leave the
   circle at the screen edge ("too far to the right on mobile"), so this sets each title's width to its longest line:
   the circle then sits just right of the title, centered on it. Re-measured when fonts load and when the width
   changes. Without JS the circle stays at the end of the row. */
(() => {
  const SEL = '.rv-hicon-text';

  const fit = (t) => {
    t.style.flex = '';
    t.style.width = '';
    const range = document.createRange();
    range.selectNodeContents(t);
    const lines = new Map();
    for (const r of range.getClientRects()) {
      if (r.width < 1) continue;
      const key = Math.round(r.top);
      const l = lines.get(key);
      lines.set(key, l ? [Math.min(l[0], r.left), Math.max(l[1], r.right)] : [r.left, r.right]);
    }
    let widest = 0;
    lines.forEach(([a, b]) => { widest = Math.max(widest, b - a); });
    const box = t.getBoundingClientRect().width;
    if (widest > 0 && widest < box - 1) {
      t.style.flex = '0 0 auto';
      t.style.width = `${Math.ceil(widest) + 1}px`;
    }
  };

  const fitAll = () => document.querySelectorAll(SEL).forEach(fit);

  let lastW = window.innerWidth;
  let raf = 0;
  const onResize = () => {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(fitAll);
  };

  const start = () => {
    if (!document.querySelector(SEL)) return;
    fitAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    window.addEventListener('resize', onResize, { passive: true });
    /* the theme editor re-renders sections */
    document.addEventListener('shopify:section:load', fitAll);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
